export class BeeError extends Error {
  constructor(message) {
    super(message);
  }
}
export class BeeArgumentError extends BeeError {
  constructor(message, value) {
    super(message);
    this.value = value;
  }
}
export class BeeResponseError extends BeeError {
  constructor(method, url, message, responseBody, status, statusText) {
    super(message);
    this.method = method;
    this.url = url;
    this.responseBody = responseBody;
    this.status = status;
    this.statusText = statusText;
  }
}